import "./index.css";

function Navbar({ children }) {
  return <div className="Navbar">{children}</div>;
}

export default Navbar;
